import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_FAVICON = `${process.env.PUBLIC_URL || ''}/logo.png?v=feather-2`;

function getFaviconLink() {
  let link = document.querySelector('link[rel~="icon"]');

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  return link;
}

function drawBadgeBackground(context) {
  context.beginPath();
  context.arc(49, 49, 13, 0, Math.PI * 2);
  context.fillStyle = '#1e3a8a';
  context.fill();
  context.lineWidth = 2.5;
  context.strokeStyle = '#ffffff';
  context.stroke();
}

function drawHomeBadge(context) {
  drawBadgeBackground(context);
  context.strokeStyle = '#ffffff';
  context.fillStyle = '#ffffff';
  context.lineWidth = 2.5;
  context.lineCap = 'round';
  context.lineJoin = 'round';

  context.beginPath();
  context.moveTo(41.5, 49);
  context.lineTo(49, 42.5);
  context.lineTo(56.5, 49);
  context.stroke();

  context.beginPath();
  context.moveTo(44, 48.5);
  context.lineTo(44, 55.5);
  context.lineTo(54, 55.5);
  context.lineTo(54, 48.5);
  context.stroke();
}

function drawSearchBadge(context) {
  drawBadgeBackground(context);
  context.strokeStyle = '#ffffff';
  context.lineWidth = 2.75;
  context.lineCap = 'round';

  context.beginPath();
  context.arc(47.5, 47.5, 5, 0, Math.PI * 2);
  context.stroke();

  context.beginPath();
  context.moveTo(51.25, 51.25);
  context.lineTo(56, 56);
  context.stroke();
}

export default function RouteFavicon() {
  const { pathname } = useLocation();

  useEffect(() => {
    const link = getFaviconLink();
    const badge = pathname === '/dashboard'
      ? 'home'
      : pathname === '/case-search'
        ? 'search'
        : null;

    if (!badge) {
      link.type = 'image/png';
      link.sizes = '354x354';
      link.href = BASE_FAVICON;
      return undefined;
    }

    const logo = new Image();
    let cancelled = false;

    logo.onload = () => {
      if (cancelled) return;

      const canvas = document.createElement('canvas');
      canvas.width = 64;
      canvas.height = 64;
      const context = canvas.getContext('2d');
      if (!context) return;

      context.clearRect(0, 0, 64, 64);
      context.drawImage(logo, 2, 2, 58, 58);

      if (badge === 'home') {
        drawHomeBadge(context);
      } else {
        drawSearchBadge(context);
      }

      link.type = 'image/png';
      link.sizes = '64x64';
      link.href = canvas.toDataURL('image/png');
    };
    logo.src = BASE_FAVICON;

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return null;
}
